//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'UiAutocompleteSuggestion',

  props: {
    suggestion: {
      type: [String, Object],
      required: true,
    },
    type: {
      type: String,
      default: 'simple', // 'simple' or 'image'
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
    keys: {
      type: Object,
      default() {
        return {
          label: 'label',
          image: 'image',
        };
      },
    },
  },

  computed: {
    classes() {
      return [
        'ui-autocomplete-suggestion--type-' + this.type,
        { 'is-highlighted': this.highlighted },
      ];
    },

    imageStyle() {
      return { 'background-image': 'url(' + this.suggestion[this.keys.image] + ')' };
    },
  },
};

